/* Rising Sun FPV - Ghost hunt (V2.8; "containment breach" pop-up added in V2.9).
   Ghosts hide on set product and collection pages; catching them all reveals a discount code.
   Spots, clues, dates, wording and the code are set in Customize > Theme settings > Ghost hunt; the clues show on /pages/ghost-hunt.
   Progress is saved in the visitor's own browser (no login). Ghosts are buttons, so they can be caught with the keyboard too.
   The pop-up shows once per browser, a few seconds into a visit, and asks the newsletter pop-up to hold off for a minute afterwards.
   Preview it any time during the hunt by adding ?rs_hunt_alert=1 to a page address. */
(function () {
  var d = document, cfgEl = d.getElementById('rs-hunt-config'), cfg;
  if (!cfgEl) return;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var today = new Date(Date.now() + 10 * 3600000).toISOString().slice(0, 10);
  if ((cfg.start && today < cfg.start) || (cfg.end && today > cfg.end)) return;

  var spots = (cfg.spots || []).map(norm), total = spots.filter(Boolean).length;
  if (!total) return;
  var code = '';
  try { code = window.atob(cfg.k || ''); } catch (e) { code = ''; }
  var page = cfg.page || '/pages/ghost-hunt', reward = cfg.reward || 'a discount', terms = cfg.terms || '';
  var KEY = 'rsGhostHunt:' + (cfg.start || ''), SEEN = 'rsGhostHuntAlert:' + (cfg.start || ''), HOLD = 'rsPopupHold', memory = [];
  var WORDS = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'];
  var GHOST = '<svg viewBox="0 0 46 54" aria-hidden="true" focusable="false"><path d="M23 2C11.4 2 4 10.6 4 22v28l6.3-5 6.4 5 6.3-5 6.3 5 6.4-5L42 50V22C42 10.6 34.6 2 23 2z" fill="rgba(109,255,159,.85)" stroke="#1b1e21" stroke-width="2.5" stroke-linejoin="round"/><ellipse cx="16.5" cy="22" rx="3.6" ry="4.6" fill="#1b1e21"/><ellipse cx="29.5" cy="22" rx="3.6" ry="4.6" fill="#1b1e21"/><ellipse cx="23" cy="33" rx="3" ry="3.6" fill="#1b1e21"/></svg>';

  function norm(p) {
    p = String(p || '').trim().toLowerCase();
    if (!p) return '';
    if (/^https?:[/][/]/.test(p)) { try { p = new URL(p).pathname; } catch (e) { return ''; } }
    p = p.split('?')[0].split('#')[0].replace(/[/]+$/, '');
    return p.charAt(0) === '/' ? p : '/' + p;
  }
  function isHere(spot) {
    if (!spot) return false;
    var path = norm(window.location.pathname), at = spot.indexOf('/products/');
    if (at !== -1) { var tail = spot.slice(at); return path === spot || path.slice(-tail.length) === tail; }
    return path === spot || (path.indexOf(spot + '/') === 0 && path.indexOf('/products/') === -1);
  }
  function load() {
    var v = null;
    try { v = JSON.parse(window.localStorage.getItem(KEY) || 'null'); } catch (e) { v = null; }
    if (!Array.isArray(v)) v = memory;
    return v.filter(function (i) { return typeof i === 'number' && spots[i]; });
  }
  function save(list) {
    memory = list.slice();
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* storage blocked: progress lasts for this page only */ }
  }
  function word(n) { return WORDS[n] || String(n); }
  function esc(t) { return String(t).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }
  function applyUrl() { return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart'); }

  var css = '' +
    '.rs-hunt-ghost{position:absolute;z-index:6;width:46px;height:54px;padding:0;margin:0;border:0;background:none;opacity:0;transition:opacity .8s;filter:drop-shadow(0 0 8px rgba(109,255,159,.55))}' +
    '.rs-hunt-ghost svg{display:block;width:100%;height:100%}' +
    '.rs-hunt-ghost.is-in{opacity:1;animation:rsHuntBob 2.6s ease-in-out infinite,rsHuntFade 4.2s ease-in-out infinite}' +
    '.rs-hunt-ghost:focus-visible{outline:2px solid #ffb000;outline-offset:4px;border-radius:8px}' +
    '.rs-hunt-ghost.is-caught{animation:rsHuntCatch .7s ease-in forwards!important}' +
    '@keyframes rsHuntBob{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}' +
    '@keyframes rsHuntFade{0%,100%{opacity:.92}50%{opacity:.45}}' +
    '@keyframes rsHuntCatch{0%{opacity:1;transform:scale(1) rotate(0)}100%{opacity:0;transform:scale(.2) rotate(540deg)}}' +
    '.rs-hunt-toast{position:fixed;left:50%;bottom:24px;z-index:2147483000;width:max-content;max-width:min(92vw,460px);padding:14px 18px;background:#1b1e21;color:#d9d5c9;border:1px solid #6dff9f;border-radius:6px;font:15px/1.45 "Atkinson Hyperlegible",Arial,sans-serif;box-shadow:0 8px 30px rgba(0,0,0,.45);opacity:0;transform:translate(-50%,20px);transition:opacity .25s,transform .25s;pointer-events:none}' +
    '.rs-hunt-toast.is-on{opacity:1;transform:translate(-50%,0);pointer-events:auto}' +
    '.rs-hunt-toast b{color:#6dff9f;font-family:"IBM Plex Mono",monospace;letter-spacing:.04em}' +
    '.rs-hunt-toast a{color:#ffb000;margin-left:6px;text-decoration:underline}' +
    '.rs-hunt-modal{position:fixed;inset:0;z-index:2147483001;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(10,12,14,.72)}' +
    '.rs-hunt-modal__panel{position:relative;box-sizing:border-box;width:min(100%,460px);max-height:calc(100vh - 32px);overflow:auto;background:#2a3036;color:#d9d5c9;border:1px solid #6dff9f;border-top:6px solid #6dff9f;border-radius:6px;padding:26px 24px 22px;text-align:center;font:16px/1.5 "Atkinson Hyperlegible",Arial,sans-serif;box-shadow:0 0 40px rgba(109,255,159,.25)}' +
    '.rs-hunt-modal__ghosts{display:flex;justify-content:center;gap:6px;margin-bottom:6px}.rs-hunt-modal__ghosts svg{width:26px;height:30px}' +
    '.rs-hunt-modal__panel h2{margin:6px 0;font:700 24px/1.2 "Chakra Petch",sans-serif;color:#f4f0e6;text-transform:uppercase;letter-spacing:.04em}' +
    '.rs-hunt-modal__panel p{margin:0 0 6px}' +
    '.rs-hunt-code{display:block;margin:14px auto 4px;padding:12px;border:1px dashed #6dff9f;font:600 24px/1 "IBM Plex Mono",monospace;color:#6dff9f;letter-spacing:.12em;user-select:all;word-break:break-all}' +
    '.rs-hunt-actions{display:flex;gap:10px;justify-content:center;flex-wrap:wrap;margin-top:14px}' +
    '.rs-hunt-btn{display:inline-block;padding:11px 16px;border:1px solid #ffb000;border-radius:4px;background:transparent;color:#ffb000;font:700 14px/1 "Chakra Petch",sans-serif;text-transform:uppercase;letter-spacing:.06em;text-decoration:none}' +
    '.rs-hunt-btn--primary{background:#ffb000;color:#1b1e21}' +
    '.rs-hunt-small{margin-top:12px!important;font-size:13px;color:#a2a69f}' +
    '.rs-hunt-close{position:absolute;top:6px;right:8px;padding:4px 10px;border:0;background:none;color:#a2a69f;font-size:28px;line-height:1}' +
    '.rs-hunt-modal{animation:rsHuntIn .25s ease-out}@keyframes rsHuntIn{from{opacity:0}}' +
    '.rs-hunt-modal--alert .rs-hunt-modal__panel{width:min(100%,440px);padding:32px 28px 20px;background:#1b1e21;border:1px solid rgba(109,255,159,.5);border-radius:0;text-align:left;box-shadow:0 30px 70px -24px rgba(0,0,0,.85);animation:rsHuntUp .3s ease-out}' +
    '@keyframes rsHuntUp{from{transform:translateY(16px)}}' +
    '.rs-hunt-modal--alert .rs-hunt-modal__panel::before{content:"";position:absolute;top:0;left:0;right:0;height:6px;background:repeating-linear-gradient(-45deg,#6dff9f 0 10px,#1b1e21 10px 20px)}' +
    '.rs-hunt-modal--alert .rs-hunt-close{top:14px;right:10px}' +
    '.rs-hunt-kicker{display:flex;align-items:center;gap:10px;margin:4px 44px 10px 0!important;font:600 13px/1.3 "IBM Plex Mono",monospace;letter-spacing:.08em;text-transform:uppercase;color:#6dff9f}' +
    '.rs-hunt-kicker i{flex:0 0 9px;height:9px;border-radius:50%;background:#ff5a4e;box-shadow:0 0 8px rgba(255,90,78,.9);animation:rsHuntBlink 1.2s steps(2,start) infinite}' +
    '@keyframes rsHuntBlink{to{visibility:hidden}}' +
    '.rs-hunt-modal--alert h2{margin:0 40px 10px 0;font-size:28px;line-height:1.15;letter-spacing:.01em}' +
    '.rs-hunt-alert-row{display:flex;align-items:flex-start;gap:16px}' +
    '.rs-hunt-alert-row p{flex:1;margin:0 0 18px;font-size:16px;line-height:1.5}' +
    '.rs-hunt-alert-ghost{flex:0 0 46px;animation:rsHuntBob 2.6s ease-in-out infinite;filter:drop-shadow(0 0 8px rgba(109,255,159,.55))}.rs-hunt-alert-ghost svg{display:block;width:46px;height:54px}' +
    '.rs-hunt-go{box-sizing:border-box;display:flex;align-items:center;justify-content:center;min-height:50px;padding:12px 18px;border-radius:2px;background:linear-gradient(90deg,#ffb000,#ff7a00);color:#1b1e21;font:700 16px/1.2 "Atkinson Hyperlegible",Arial,sans-serif;letter-spacing:.06em;text-transform:uppercase;text-decoration:none}' +
    '.rs-hunt-go:focus-visible,.rs-hunt-later:focus-visible,.rs-hunt-close:focus-visible{outline:3px solid #ffb000;outline-offset:3px}' +
    '.rs-hunt-later{display:block;margin:10px auto 0;padding:8px 12px;border:0;background:none;color:#a2a69f;font:15px/1.2 "Atkinson Hyperlegible",Arial,sans-serif;text-decoration:underline}' +
    '@media (max-width:599px){.rs-hunt-modal--alert{align-items:flex-end;padding:0}.rs-hunt-modal--alert .rs-hunt-modal__panel{width:100%;max-height:88vh;padding:28px 18px calc(18px + env(safe-area-inset-bottom,0px));border-left:0;border-right:0;border-bottom:0;animation-name:rsHuntSheet}.rs-hunt-modal--alert h2{font-size:23px}}' +
    '@keyframes rsHuntSheet{from{transform:translateY(100%)}}' +
    '@media (prefers-reduced-motion:reduce){.rs-hunt-ghost.is-in{animation:none;opacity:.85}.rs-hunt-ghost.is-caught{animation:none!important;opacity:0}.rs-hunt-toast{transition:none}.rs-hunt-modal,.rs-hunt-modal--alert .rs-hunt-modal__panel,.rs-hunt-alert-ghost,.rs-hunt-kicker i{animation:none!important}}';
  var style = d.createElement('style');
  style.id = 'rs-hunt-css';
  style.textContent = css;
  d.head.appendChild(style);

  var toastEl = null, toastTimer = 0;
  function toast(html) {
    if (!toastEl) {
      toastEl = d.createElement('div');
      toastEl.className = 'rs-hunt-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      d.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 7000);
  }

  function copy(btn) {
    function done() { btn.textContent = 'Copied'; setTimeout(function () { btn.textContent = 'Copy code'; }, 2000); }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, function () { btn.textContent = code; });
    } else { btn.textContent = code; }
  }

  /* One pop-up shell for both the "containment breach" alert and the reward: focus stays inside, Escape or the backdrop closes it */
  function openModal(kind, labelId, inner, onClose) {
    var back = d.activeElement, m = d.createElement('div');
    m.className = 'rs-hunt-modal rs-hunt-modal--' + kind;
    m.innerHTML = '<div class="rs-hunt-modal__panel" role="dialog" aria-modal="true" aria-labelledby="' + labelId + '">' +
      '<button type="button" class="rs-hunt-close" aria-label="Close">&times;</button>' + inner + '</div>';
    d.body.appendChild(m);
    function close() {
      if (!m.parentNode) return;
      m.remove();
      d.removeEventListener('keydown', onKey);
      if (back && back.focus) back.focus();
      if (onClose) onClose();
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var f = m.querySelectorAll('button, a[href]'), first = f[0], last = f[f.length - 1];
        if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    m.addEventListener('click', function (e) { if (e.target === m || e.target.closest('.rs-hunt-close, [data-close]')) close(); });
    d.addEventListener('keydown', onKey);
    (m.querySelector('[data-focus]') || m.querySelector('.rs-hunt-close')).focus();
    return m;
  }

  function showWin() {
    if (d.querySelector('.rs-hunt-modal')) return;
    var ghosts = '';
    for (var i = 0; i < Math.min(total, 10); i++) ghosts += GHOST;
    var m = openModal('win', 'rs-hunt-win-title',
      '<div class="rs-hunt-modal__ghosts">' + ghosts + '</div>' +
      '<h2 id="rs-hunt-win-title">All ' + word(total) + ' ghosts caught</h2>' +
      (code ? '<p>Nice hunting. Here&rsquo;s ' + esc(reward) + ' as a thank-you.</p><code class="rs-hunt-code"></code>' +
        '<div class="rs-hunt-actions"><button type="button" class="rs-hunt-btn rs-hunt-btn--primary" data-copy data-focus>Copy code</button><a class="rs-hunt-btn" href="' + applyUrl() + '">Apply to my cart</a></div>' +
        (terms ? '<p class="rs-hunt-small"></p>' : '')
        : '<p>Nice hunting. Show this screen in store or contact us to claim your reward.</p>'));
    var codeEl = m.querySelector('.rs-hunt-code'), small = m.querySelector('.rs-hunt-small'), copyBtn = m.querySelector('[data-copy]');
    if (codeEl) codeEl.textContent = code;
    if (small) small.textContent = terms;
    if (copyBtn) copyBtn.addEventListener('click', function () { copy(copyBtn); });
  }

  /* "Containment breach" pop-up */
  function store(type) {
    try { var s = window[type]; s.setItem('__rs_hunt', '1'); s.removeItem('__rs_hunt'); return s; } catch (e) { return null; }
  }
  var seenStore = store('localStorage') || store('sessionStorage'), session = store('sessionStorage');
  function hold(ms) { if (session) { try { session.setItem(HOLD, String(Date.now() + ms)); } catch (e) { /* ignore */ } } }
  function alertSeen() { try { return !seenStore || seenStore.getItem(SEEN) === '1'; } catch (e) { return true; } }
  function forced() { try { return new URLSearchParams(window.location.search).get('rs_hunt_alert') === '1'; } catch (e) { return false; } }
  function busy() {
    if (d.hidden || d.documentElement.classList.contains('rs-booting')) return true;
    var layers = d.querySelectorAll('.drawer[aria-hidden="false"], .modal[aria-hidden="false"], .popover[aria-hidden="false"], [aria-modal="true"], [data-rs-nl].is-open');
    for (var i = 0; i < layers.length; i++) { var r = layers[i].getBoundingClientRect(); if (r.width > 1 && r.height > 1) return true; }
    var ae = d.activeElement;
    return !!(ae && ['INPUT', 'TEXTAREA', 'SELECT'].indexOf(ae.tagName) !== -1);
  }
  function showAlert() {
    if (d.querySelector('.rs-hunt-modal')) return;
    var a = cfg.alert || {}, n = word(total);
    var text = a.text || (n.charAt(0).toUpperCase() + n.slice(1) + ' ghosts have escaped into the store. Use the clues to track them down and catch all ' + n + ' for ' + reward + '.');
    var m = openModal('alert', 'rs-hunt-alert-title',
      '<p class="rs-hunt-kicker"><i aria-hidden="true"></i>Priority alert</p>' +
      '<h2 id="rs-hunt-alert-title"></h2>' +
      '<div class="rs-hunt-alert-row"><p></p><span class="rs-hunt-alert-ghost">' + GHOST + '</span></div>' +
      '<a class="rs-hunt-go" data-focus href="' + esc(page) + '">Start the hunt</a>' +
      '<button type="button" class="rs-hunt-later" data-close>Not now</button>',
      function () { hold(60000); });
    m.querySelector('h2').textContent = a.title || 'Containment breach';
    m.querySelector('.rs-hunt-alert-row p').textContent = text;
    hold(600000);
    try { if (seenStore) seenStore.setItem(SEEN, '1'); } catch (e) { /* ignore */ }
  }
  function queueAlert() {
    var a = cfg.alert || {};
    if (forced()) { showAlert(); return; }
    if (!a.on || (window.Shopify && window.Shopify.designMode) || alertSeen() || load().length) return;
    var type = (window.theme && window.theme.pageType) || '';
    if (type === 'cart' || type === 'password' || type === 'gift_card' || type.indexOf('customers') === 0) return;
    if (norm(window.location.pathname) === norm(page)) return;
    var tries = 0;
    function attempt() {
      if (alertSeen() || load().length) return;
      if (busy()) {
        /* If the newsletter pop-up got in first, leave this for a later page so they never stack */
        if (d.querySelector('[data-rs-nl].is-open') || ++tries > 15) return;
        setTimeout(attempt, 3000);
        return;
      }
      showAlert();
    }
    setTimeout(attempt, Math.max(1, Number(a.delay) || 5) * 1000);
  }

  function anchorFor() {
    var type = (window.theme && window.theme.pageType) || '', a = null, pos;
    if (type === 'product') {
      a = d.querySelector('.product-gallery') || d.querySelector('.product-meta');
      pos = { top: '14px', right: '14px' };
    } else if (type === 'collection') {
      var t = d.querySelector('.collection__title');
      a = t && (t.closest('.card__header') || t.parentElement);
      pos = { top: '50%', right: '18px', marginTop: '-27px' };
    }
    if (!a) return { el: d.body, pos: { position: 'fixed', top: '42%', right: '18px' } };
    if (window.getComputedStyle(a).position === 'static') a.style.position = 'relative';
    return { el: a, pos: pos };
  }

  function placeGhost(i) {
    var spot = anchorFor(), btn = d.createElement('button');
    btn.type = 'button';
    btn.className = 'rs-hunt-ghost';
    btn.setAttribute('aria-label', 'A ghost! Catch it');
    btn.innerHTML = GHOST;
    Object.keys(spot.pos).forEach(function (k) { btn.style[k] = spot.pos[k]; });
    spot.el.appendChild(btn);
    setTimeout(function () { btn.classList.add('is-in'); }, 1200);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) return;
      btn.disabled = true;
      var list = load();
      if (list.indexOf(i) === -1) list.push(i);
      save(list);
      btn.classList.add('is-caught');
      setTimeout(function () { btn.remove(); }, 750);
      var n = list.length;
      updateBoard();
      if (n >= total) setTimeout(showWin, 450);
      else toast('<b>Ghost caught!</b> ' + n + ' of ' + total + ' found, ' + (total - n) + ' still loose.<a href="' + esc(page) + '">See the clues</a>');
    });
  }

  function updateBoard() {
    var board = d.querySelector('[data-rs-hunt-board]');
    if (!board) return;
    var list = load(), n = list.length;
    Array.prototype.forEach.call(board.querySelectorAll('[data-rs-hunt-clue]'), function (li) {
      var got = list.indexOf(parseInt(li.getAttribute('data-rs-hunt-clue'), 10)) !== -1, s = li.querySelector('[data-rs-hunt-status]');
      li.classList.toggle('is-caught', got);
      if (s) s.textContent = got ? 'Caught' : 'Still loose';
    });
    Array.prototype.forEach.call(board.querySelectorAll('[data-rs-hunt-count]'), function (el) { el.textContent = n; });
    Array.prototype.forEach.call(board.querySelectorAll('[data-rs-hunt-pips] span'), function (p, k) { p.classList.toggle('is-on', k < n); });
    var win = board.querySelector('[data-rs-hunt-win]');
    if (win && n >= total && code) {
      win.hidden = false;
      var c = win.querySelector('[data-rs-hunt-code]'), a = win.querySelector('[data-rs-hunt-apply]'), b = win.querySelector('[data-rs-hunt-copy]');
      if (c) c.textContent = code;
      if (a) a.href = applyUrl();
      if (b && !b.dataset.bound) { b.dataset.bound = '1'; b.addEventListener('click', function () { copy(b); }); }
    }
  }

  function addTickerLine() {
    var lists = d.querySelectorAll('.rs-ticker__list');
    Array.prototype.forEach.call(lists, function (ul) {
      if (ul.querySelector('.rs-ticker__item--hunt')) return;
      var li = d.createElement('li'), a = d.createElement('a');
      li.className = 'rs-ticker__item rs-ticker__item--hunt';
      a.href = page;
      a.textContent = 'Ghost hunt: ' + word(total) + ' ghosts are loose in the store. Catch them all for ' + reward;
      if (ul.getAttribute('aria-hidden') === 'true') a.setAttribute('tabindex', '-1');
      li.appendChild(a);
      var live = ul.querySelector('[data-rs-ticker-live]');
      ul.insertBefore(li, live ? live.nextSibling : ul.firstChild);
    });
  }

  function init() {
    addTickerLine();
    updateBoard();
    var list = load();
    spots.forEach(function (s, i) { if (s && list.indexOf(i) === -1 && isHere(s)) placeGhost(i); });
    window.addEventListener('storage', function (e) { if (e.key === KEY) updateBoard(); });
    queueAlert();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();